import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export const usePreferencesStore = create(
	persist(
		(set) => ({
			sidebarCollapsed: false,
			setSidebarCollapsed: (val) => set({ sidebarCollapsed: val }),

			dashboardProgress: { completedSteps: [], isVisible: true },
			setDashboardProgress: (val) => set({ dashboardProgress: val }),

			prospectQuerySelectorSharedSectionOpen: true,
			setProspectQuerySelectorSharedSectionOpen: (val) => set({ prospectQuerySelectorSharedSectionOpen: val }),

			// How a new lead search starts: the filter form or the autonomous agent.
			leadSearchMode: 'form',
			setLeadSearchMode: (val) => set({ leadSearchMode: val }),

			lastSelectedSearchQueryId: null,
			setLastSelectedSearchQueryId: (val) => set({ lastSelectedSearchQueryId: val }),

			demoUpgradeBannerDismissed: false,
			setDemoUpgradeBannerDismissed: (val) => set({ demoUpgradeBannerDismissed: val }),

			leadOverviewTourCompleted: false,
			setLeadOverviewTourCompleted: (val) => set({ leadOverviewTourCompleted: val }),

			// One-time "first open" hint per add-on, keyed by addonKey (e.g. { crm: true }).
			addonHintShown: {},
			markAddonHintShown: (addonKey) =>
				set((s) => ({ addonHintShown: { ...s.addonHintShown, [addonKey]: true } })),

			hideApprovedEmails: false,
			setHideApprovedEmails: (val) => set({ hideApprovedEmails: val }),

			crmActivityFilters: { status: 'planned', activityType: '', channelTypeId: '', userId: 'me' },
			setCrmActivityFilters: (val) => set({ crmActivityFilters: val }),

			// Grid/list choice per collection page, keyed by scope (e.g. { contactLists: 'list' }).
			collectionViewModes: {},
			setCollectionViewMode: (scope, mode) =>
				set((s) => ({ collectionViewModes: { ...s.collectionViewModes, [scope]: mode } })),

			crmActivityView: 'list',
			setCrmActivityView: (val) => set({ crmActivityView: val }),

			lastSelectedCrmPipelineId: null,
			setLastSelectedCrmPipelineId: (val) => set({ lastSelectedCrmPipelineId: val }),

			kanbanScrollPositions: {},
			setKanbanScroll: (pipelineId, positions) =>
				set((s) => ({
					kanbanScrollPositions: { ...s.kanbanScrollPositions, [pipelineId]: positions },
				})),

			calendarVisibility: {},
			setCalendarVisibility: (connectionId, visible) =>
				set((s) => ({
					calendarVisibility: { ...s.calendarVisibility, [connectionId]: visible },
				})),

			// Column order and visibility per table, keyed by the Table `layoutKey`; null resets to defaults.
			tableLayouts: {},
			setTableLayout: (layoutKey, layout) =>
				set((s) => {
					const { [layoutKey]: _previous, ...rest } = s.tableLayouts;
					return { tableLayouts: layout ? { ...rest, [layoutKey]: layout } : rest };
				}),

			// User-dragged width (px) of a table's first column, keyed by the Table `layoutKey`; null resets.
			tableFirstColumnWidths: {},
			setTableFirstColumnWidth: (layoutKey, width) =>
				set((s) => {
					const { [layoutKey]: _previous, ...rest } = s.tableFirstColumnWidths;
					return { tableFirstColumnWidths: width ? { ...rest, [layoutKey]: width } : rest };
				}),

			// Last-used recipient role priority (shared by CSV export + add-to-list modals).
			// null = never customized; consumers fall back to DEFAULT_ROLE_PRIORITY.
			contactRolePriority: null,
			setContactRolePriority: (val) => set({ contactRolePriority: val }),
		}),
		{ name: 'b2bhero:preferences' },
	),
);
